export class TipologiaServizio {
  id: number = null;
  codice: string = null;
  descrizione: string = null;
  raggruppamentoId: number = null;
  raggruppamentoCodice: string = null;
  raggruppamentoDescrizione: string = null;
  serviziRendicontati: boolean = false;
}
